const messages = {
  en: {
    // NavBar
    homeButton: `Home`,
    albumsButton: `Photo Albums`,
    switchToLang: 'Cambiar a español',

    // Home
    rebeccaAndEricsWedding: 'Rebecca and Eric’s Wedding',
    gotMarriedSubhed: 'Got married!',
    heroAlt: `Eric and Rebecca walk down the aisle together after being wed.`,
    dateAndPlace: 'Date & Place',
    weddingDate: 'Sunday, March 18, 2018',
    dateAndPlaceCopy: `
      On {weddingDate}, both the ceremony and the reception took place at
      {theStillwellHouseLink} in downtown {tucsonAZLink}!
    `,
    theStillwellHouse: 'The Stillwell House and Garden',
    ourPhotos: `Our Photos`,
    ourPhotosCopy: `
      Both our {weddingAlbumLink} and our {honeymoonAlbumLink} are now online.
    `,
    weddingPhotos: `wedding photos`,
    honeymoonPhotos: `honeymoon photos`,

    // AlbumList
    albumListTitle: 'Eric and Rebecca’s Photo Albums',
    photoAlbumsSubtitle: `Photo Albums`,
    weddingAlbumTitle: `Our Wedding`,
    honeymoonAlbumTitle: `Our Honeymoon`,
    cakeTopperAlt: `Lego wedding cake topper.`,
    akakaFallsAlt: `Rebecca and Eric at Akaka Falls State Park.`,

    // Album
    weddingAlbumPageTitle: `Rebecca and Eric’s Wedding Photos`,
    honeymoonAlbumPageTitle: `Rebecca and Eric’s Honeymoon Photos`,
    rebeccaAndEricsWeddingPhotos: `Rebecca and Eric’s Wedding Photos`,
    weddingPhotosTitle: `Wedding Photos`,
    photosIntroPara: `
      All our photos were taken by the amazing {loriOTooleLink}. You may order
      prints through her {printServiceLink}—just ask us for the password.
    `,
    printService: `print service`,
    thumbnailUserInstructions: `Click any thumbnail below to open the photo gallery.`,

    // FourOhFour
    cantFindThat: `Can’t find that!`,
    sorry404: `Sorry, what you’re looking for cannot be found.`,
  },
  es: {
    // NavBar
    homeButton: `Hogar`,
    albumsButton: `Álbumes de fotos`,
    switchToLang: 'Switch to English',

    // Home
    rebeccaAndEricsWedding: 'La boda de Rebecca y Eric',
    gotMarriedSubhed: '¡Se casaron!',
    heroAlt: `Eric y Rebecca caminan por el pasillo juntos después de casarse.`,
    dateAndPlace: 'Fecha y lugar',
    weddingDate: 'domingo 18 de marzo de 2018',
    dateAndPlaceCopy: `
      El {weddingDate}, la ceremonia y la recepción se realizaron en
      {theStillwellHouseLink} en el centro de {tucsonAZLink}.
    `,
    theStillwellHouse: 'la Stillwell House and Garden',
    ourPhotos: `Nuestras fotos`,
    ourPhotosCopy: `
       {weddingAlbumLink} y {honeymoonAlbumLink} ahora están
       en línea.
    `,
    weddingPhotos: `Fotos de nuestra boda`,
    honeymoonPhotos: `fotos de nuestra luna de miel`,

    // AlbumList
    albumListTitle: `Álbumes de fotos de Eric y Rebecca`,
    photoAlbumsSubtitle: `Álbumes de fotos`,
    weddingAlbumTitle: `Nuestra boda`,
    honeymoonAlbumTitle: `Nuestra luna de miel`,
    cakeTopperAlt: `Figurita de Lego para el pastel de bodas.`,
    akakaFallsAlt: `Rebecca y Eric en el Parque Estatal Akaka Falls.`,

    // Album
    weddingAlbumPageTitle: `Fotos de la boda de Rebecca y Eric`,
    honeymoonAlbumPageTitle: `Fotos de luna de miel de Rebecca y Eric`,
    rebeccaAndEricsWeddingPhotos: `Photos de la boda de Rebecca y Eric`,
    weddingPhotosTitle: `Fotos de la boda`,
    photosIntroPara: `
      Todas nuestras fotos fueron tomadas por la increíble {loriOTooleLink}.
      Puede comprar impresiones a través de su {printServiceLink}; solo
      solicítenos la contraseña.
    `,
    printService: `servicio de impresión`,
    thumbnailUserInstructions: `Haga clic en cualquier miniatura de abajo para abrir la galería de fotos.`,

    cantFindThat: `¡no pueden encontrar eso!`,
    sorry404: `Lo sentimos, lo que estás buscando no se puede encontrar.`,
  },
}

export default messages



// WEBPACK FOOTER //
// ./src/messages.js